import React from "react"
import Ample from "../components/ample/ample"
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { TOOLS, getToolPageTitle } from "../optiontools";

const CondorBuilderPage = (props) => {
  return (
    <Ample currPageTitle={getToolPageTitle(TOOLS.CONDOR_BUILDER)} location={props.location.href}>
      <h1 style={{position: 'absolute', width: '1px', height: '1px', margin: '-1px', padding: 0, overflow: 'hidden', clip: 'rect(0,0,0,0)', border: 0}}>
        {getToolPageTitle(TOOLS.CONDOR_BUILDER)}
      </h1>
      <div className="row">
          <div className="col-md-12">
              <div className="white-box">
                  <div className="box-title" style={{textTransform: 'none'}}>Condor Builder</div>
                  <Alert severity="warning" style={{marginTop: "12px"}}>
                    <AlertTitle>Not Implemented</AlertTitle>
                    Coming soon
                  </Alert>
              </div>
          </div>
          </div>
    </Ample>);
};
export default CondorBuilderPage;